const CATEGORY_MATCHERS = {
  Committees: (category) => category?.includes('Committee'),
  Commons: (category) => category === 'House of Commons',
  Lords: (category) => category === 'House of Lords',
  'Westminster Hall': (category) => category === 'Westminster Hall',
};

export const EVENT_SECTIONS = ['Commons', 'Lords', 'Committees', 'Westminster Hall', 'Other'];

const filterTranscriptsByCategory = (items, activeSection) => {
  if (activeSection === 'All') return items;
  if (activeSection === 'Other') {
    return items.filter((item) => !Object.values(CATEGORY_MATCHERS).some((matches) => matches(item.eventCategory)));
  }
  const matches = CATEGORY_MATCHERS[activeSection];
  return matches ? items.filter((item) => matches(item.eventCategory)) : items;
};

// Items with no known start time sort after every timed item, instead of jumping to the front.
// Events carry scheduledStartDateTime; debates carry actualStartDateTime (from the Hansard record).
const NO_START_TIME = Number.MAX_SAFE_INTEGER;
const startTimeMs = (item) => {
  const startAt = item.scheduledStartDateTime ?? item.actualStartDateTime;
  return startAt ? new Date(startAt).getTime() : NO_START_TIME;
};

// Groups items under each section that has at least one match, in EVENT_SECTIONS order,
// sorted by start time within each section.
export const groupTranscriptsByCategory = (items) =>
  EVENT_SECTIONS.map((section) => ({
    section,
    items: filterTranscriptsByCategory(items, section).sort((a, b) => startTimeMs(a) - startTimeMs(b)),
  })).filter((group) => group.items.length > 0);

export default filterTranscriptsByCategory;
